<span>
    <p style="margin-top: 25px;">
        <a (click)="verfacilites()" [ngClass]="{'selected': activeLink === 'facilities'}"
            class="image-cruise facilities-a">Cruise</a> &nbsp;|&nbsp;
        <a (click)="verfotos()" [ngClass]="{'selected': activeLink === 'photos'}"
            class="image-cruise facilities-a facilities-b">Photos</a> &nbsp;|&nbsp;
        <a (click)="veritinerario()" [ngClass]="{'selected': activeLink === 'itinerary'}"
            class="image-cruise facilities-a">Itinerary</a> &nbsp;|&nbsp;
        <a (click)="verincluye()" [ngClass]="{'selected': activeLink === 'included'}"
            class="image-cruise facilities-a">Included</a> &nbsp;|&nbsp;
        <a (click)="vernoincluye()" [ngClass]="{'selected': activeLink === 'notIncluded'}"
            class="image-cruise facilities-a">Not Included</a> &nbsp;|&nbsp;
        <span *ngIf="isVisibleReview()">
            <a onclick="document.getElementById('reviews').click()" [ngClass]="{'selected': activeLink === 'reviews'}"
                (click)="verreview()" class="image-cruise facilities-a">Reviews</a>&nbsp;|&nbsp;
        </span>
        <span *ngIf="activatedFaqs">
            <a (click)="verfaqs()" [ngClass]="{'selected': activeLink === 'faqs'}"
                class="image-cruise facilities-a">FAQs</a> &nbsp;|&nbsp;
        </span>
        <!-- / NAV SECTION -->
        <!-- FACILITIES SECTION -->
    <div *ngIf="facilities">
        <h4>Yacht Facilities </h4>
        <div [ngClass]="{'animated-section': facilities, 'animated-insection': !facilities}" class="collapse show"
            [collapse]="!collapsedFacilities" [isAnimated]="true">
            <p class="text-justify">{{ boatInfo.description }}</p>
            <div class="row mt20">
                <div class="col-md-6">
                    <div *ngFor="let c of amenities_one" class="cruise-facilities">
                        <img src="assets/icons/{{c}}.png" height="25" />
                        <span class="cruise-facilities-span">{{c}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- / FACILITIES SECTION -->
    <!-- GALLERY SECTION -->
    <div *ngIf="fotos">
        <h4>Photos Of The Cruise</h4>
        <div *ngIf="detailViewTemplate == 'center'">
            <app-cruise-information-picture-carousel [images]="galleryImage"></app-cruise-information-picture-carousel>
        </div>
        <div *ngIf="detailViewTemplate != 'center'">
            <div [ngClass]="{'animated-section': fotos, 'animated-insection': !fotos}" id="gallery"
                class="carousel slide carousel-fade">
                <div class="carousel-inner" role="listbox">
                    <div *ngFor="let image of galleryImage; let i = index" class="carousel-item"
                        [class.active]="i === currentImage">
                        <img [src]="pathCruisePhotos + image" height="auto" width="100%">
                    </div>
                </div>
                <span class="carousel-control-prev" (click)="prev()" *ngIf="currentImage > 0">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </span>
                <span class="carousel-control-next" (click)="next()" *ngIf="currentImage < boatInfo.images.length - 1">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </span>
                <ol class="carousel-indicators">
                    <li *ngFor="let picture of galleryImage; let i = index" (click)="selectImage(i)">
                        <img class="d-block w-100 img-fluid" [src]="pathCruisePhotos + picture" height="100">
                    </li>
                </ol>
            </div>
        </div>
    </div>
    <!-- / GALLERY SECTION -->
    <!-- ITINERARIES SECTION -->
    <div *ngIf="itinerario">
        <h4>what's The Itinerary?</h4>
        <div [ngClass]="{'animated-section': itinerario, 'animated-insection': !itinerario}" id="itinerariy"
            class="carousel slide carousel-fade; collapse show" [collapse]="collapsedIncludes" [isAnimated]="true">

            <div class="carousel-inner" role="listbox">
                <img [src]="pathItinerary + imagesItinerary[currentItinerary]" height="auto" width="100%">
            </div>
            <div style="padding: 15px">
                <app-rating *ngIf="isVisibleRating()" size="small" name="Flora & Fauna"
                    [rating]=itinerarySelected.floraFaunaRating></app-rating>
                <app-rating *ngIf="isVisibleRating()" size="small" name="Landscapes"
                    [rating]=itinerarySelected.landscapesRating></app-rating>
                <app-rating *ngIf="isVisibleRating()" size="small" name="Activities"
                    [rating]=itinerarySelected.activitiesRating></app-rating>
            </div>
            <app-itinerary-details [itineraries]="getItineraries()" [className]="'table-striped'"
                [isIncludeTableHeader]="true" [isWidthComplete]="true"
                [tourLengthShortName]="boatInfo.availability[0].name" [cruiseName]="boatInfo.name"
                [daysItinerary]="boatInfo.availability[0].length?.substring(0,1)" 
                [itineraryDescription]="getItineraryDescription()">
            </app-itinerary-details>
            <p class="mt-3" style="text-align: justify; font-size: 12px;">{{itineraryDisclaimer}}</p>
        </div>
    </div>

    <!-- / ITINERARIES SECTION -->
    <!-- INCLUDED SECTION -->
    <div id='includes' *ngIf="incluye">
        <h4>What Include?</h4>
        <div [ngClass]="{'animated-section': incluye, 'animated-insection': !incluye}" class="collapse show"
            [collapse]="collapsedIncludes" [isAnimated]="true">

            <div *ngFor="let include of featureInclude">
                <li class="fa fa-check" [ngStyle]="{ 'color': '#'+this.companyParams.getMainColor() }">

                </li>
                {{include.name}}
            </div>
        </div>
    </div>

    <!-- / INCLUDED SECTION -->
    <!-- NOT INCLUDED SECTION -->
    <div *ngIf="noincluye">
        <h4>What Not Include?</h4>
        <div [ngClass]="{'animated-section': noincluye, 'animated-insection': !noincluye}" class="collapse show"
            [collapse]="collapsedNoIncludes" [isAnimated]="true">
            <div *ngFor="let noInclude of featureNoInclude" style="display: flex;">
                <li class="fa fa-times" aria-hidden="true" style="color: red;" style="padding-right: 4px;">

                </li> {{noInclude.name}}
            </div>
        </div>
    </div>
    <!-- / NOT INCLUDED SECTION -->
    <!-- REVIEW SECTION -->
    <div *ngIf="review">
        <h4>Reviews</h4>
        <div [ngClass]="{'animated-section': review, 'animated-insection': !review}">
            <div class="collapse show" [collapse]="collapsedReviews" [isAnimated]="true">
                <div>
                    <app-card-review *ngFor="let comment of boatInfo.comments" [comment]="comment"
                        style="width: 380px;"></app-card-review>
                </div>
            </div>
        </div>
    </div>
    <!-- FAQs -->
    <div *ngIf="faqs" class="faq-content">
        <h2>FAQs</h2>
        <br>
        <div [ngClass]="{'animated-section': review, 'animated-insection': !review}">
            <div *ngFor="let faq of boatInfo?.faqs" class="faq-item">
                <div class="question">
                    <span class="faq-question-prefix"
                        [ngStyle]="{ 'color': '#' + companyParams.getSecundaryColor() }">Q: </span>
                    {{ faq.question }}
                </div>
                <div class="answer">
                    <strong>A:</strong> {{ faq.answer }}
                </div>
            </div>
        </div>
    </div>
    <!-- /FAQs-->
</span>

<br>